import { initMetaPixel } from './metaPixel'
import { PUBLIC_ENVIRONMENT } from '$env/static/public'
import { initGoogleTagManager } from './google'

export function initTracking() {
  if (window && window.location.hostname !== 'localhost') {
    if (PUBLIC_ENVIRONMENT === 'production') {
      initGoogleTagManager()
      initMetaPixel()
    }
  }
}
